import { useEffect, useState } from 'react';
import { Customer } from '../../../../domain/customers/customer';
import { Link, useNavigate } from 'react-router-dom';
import { CreateCustomer } from '../../../../domain/customers/createCustomer';
import { CustomersRepository } from '../../../../infrastructure/repositories/customers/customerRepository';
import { Private_Routes } from '../../../../main/constants';
import { UpdateCustomer } from '../../../../domain/customers/updateCustomer';
import FormErrorMessage from '../../../shared/components/forms/FormErrorMessage';
import CustomerInformationSection from './CustomerInformationSection';
import Swal from 'sweetalert2';

interface Props {
    isNewCustomer: boolean;
    customer?: Customer | null;
}

export const CustomerForm = ({
    isNewCustomer,
    customer: selectedCustomer,
}: Props) => {
    const initialState = selectedCustomer ?? {
        id: 0,
        cityName: '',
        cityId: 0,
        commercialName: '',
        email: '',
        documentNumber: '',
        phoneNumber: '',
        cellphoneNumber: '',
        address: '',
        code: '',
        classification: 0,
        isActive: false,
    };

    const [customer, setCustomer] = useState<Customer>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isIncomplete, setIsIncomplete] = useState(true);

    const navigate = useNavigate();

    const handleInputChange = (
        name: string,
        value: string | boolean | number[] | number | undefined
    ) => {
        setCustomer({ ...customer, [name]: value });
    };

    const handleError = (error: any) => {
        setErrorMessage(error.response.data);
        setIsSubmitting(false);
        window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        setIsSubmitting(true);
        setErrorMessage('');

        if (isNewCustomer) {
            let body: CreateCustomer = {
                cityId: customer.cityId,
                documentNumber: customer.documentNumber,
                address: customer.address,
                code: customer.code,
                classification: Number(customer.classification),
                commercialName: customer.commercialName,
            };

            CustomersRepository.CreateCustomer(body)
                .then((response) => {
                    navigate(Private_Routes.CUSTOMER_PAGE);
                    setIsSubmitting(false);
                    Swal.fire('Cliente creado exitosamente!', '', 'success');
                })
                .catch(handleError);
        } else {
            let body: UpdateCustomer = {
                cityId: customer.cityId,
                documentNumber: customer.documentNumber,
                address: customer.address,
                code: customer.code,
                classification: Number(customer.classification),
                commercialName: customer.commercialName,
                isActive: customer.isActive,
            };

            CustomersRepository.UpdateCustomer(body, customer.id)
                .then((response) => {
                    navigate(Private_Routes.CUSTOMER_PAGE);
                    setIsSubmitting(false);
                    Swal.fire('Cliente actualizado exitosamente!', '', 'success');
                })
                .catch(handleError);
        }
    };

    useEffect(() => {
        if (
            customer.cityId > 0 &&
            customer.commercialName !== '' &&
            customer.documentNumber !== '' &&
            customer.code !== ''
        ) {
            setIsIncomplete(false);
        } else {
            setIsIncomplete(true);
        }
    }, [customer]);

    return (
        <div>
            <FormErrorMessage errorMessage={errorMessage} />
            <div className='row'>
                <div className='col-xxl-12'>
                    <div className='card '>
                        <div className='card-body p-4'>
                            <div className='row'>
                                <CustomerInformationSection
                                    isNewCustomer={isNewCustomer}
                                    customer={customer}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-flex gap-2'>
                    <Link
                        to={Private_Routes.CUSTOMER_PAGE}
                        className='btn btn-withe'
                    >
                        <i className='mdi mdi-arrow-left'></i> Atrás
                    </Link>

                    {isNewCustomer ? (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            {isSubmitting ? 'Creando...' : 'Crear'}
                        </button>
                    ) : (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            <i className='ri-arrow-up-circle-line'></i>
                            {isSubmitting ? 'Actualizando...' : 'Actualizar'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
